import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="problema-title" data-id="element-213" data-mp="30h7nzw0x86xq">
      <div className="mx-auto max-w-5xl" data-id="element-214" data-mp="2vq7nyhwi98r0">
        <SectionHeading title="¿Cuántas semanas más vas a entrenar sin progresar?" align="center" data-id="element-215" data-mp="2vp6dofnbcqac" />
        <div className="mx-auto mt-8 max-w-3xl space-y-5 text-center" data-id="element-216" data-mp="35gar3axcc332">
          <p className="text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-217" data-mp="35g0wtb59j9rk">
            Entrenás calistenia. La amás. Pero nadie te dijo que ibas a pasar
            meses haciendo las mismas dominadas sin subir de nivel, siguiendo
            rutinas de YouTube que no encajan con tu cuerpo y llegando al
            entrenamiento sin saber exactamente qué trabajar.
          </p>
          <p id="problema-title" className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-218" data-mp="1k4is8lzfnr24">
            No es falta de esfuerzo. Es falta de un sistema.
          </p>
        </div>

        <ul className="mt-12 grid gap-3 md:grid-cols-2" data-id="element-219" data-mp="o9u5lgvathfh">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl border border-line bg-ink p-4" data-id="element-220" data-mp="sbyw46qg9xxw">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ember/15" aria-hidden="true" data-id="element-221" data-mp="122jrzmeqood4">
                <XIcon className="h-3.5 w-3.5 text-ember" data-id="element-222" data-mp="1c1izv2rokfz2" />
              </span>
              <span className="text-sm leading-relaxed text-neutral-300" data-id="element-223" data-mp="1g3498e50ac4i">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mt-12 text-center text-2xl font-extrabold leading-tight tracking-tight text-gold sm:text-4xl" data-id="element-224" data-mp="3duyro2zi80vm">
          ¿Y si esta fuera la última semana que entrenás sin sistema?
        </p>
      </div>
    </section>;
}